import { action, API, controller } from "api";
import DynamicTable from "layout/DynamicTable/DynamicTable";
import React, { useContext, useEffect, useState } from "react";
import Header from "./Header";
import { Alert, Dialog } from "layout";
import AddEditFollowUp from "./AddEditFollowUp";
import { useNavigate } from "react-router-dom";
import Actions from "./Actions";
import { ToFormData } from "hooks";
import { toast } from "react-toastify";
import InquiryStatusWidget from "./InquiryStatusWidget";
import { AppContext } from "App";

const Inquiries = () => {
  const { access } = useContext(AppContext);
  const navigate = useNavigate();
  const [tblData, setTblData] = useState([]);
  const [inqs, setInqs] = useState([]);
  const [followUp, setFollowUp] = useState(false);
  const [inqData, setInqData] = useState();
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleFollowup = (data) => {
    setInqData(data);
    setFollowUp(true);
  };

  const handleAddEdit = (id) => {
    navigate(`/inquiry_form/${id || ""}`);
  };
  const handleView = (id) => {
    navigate(`/view_inquiry/${id}`);
  };

  const handleUpdateStatus = (value) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: `Proceed with ${value.status === 2 ? "Closing" : "Completion"}?`,
      subTitle: `Once marked as ${
        value.status === 2 ? "Closed" : "Completed"
      }, you won’t be able to make changes. Do you want to continue?`,
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: false,
              type: "",
              title: "",
              subTitle: "",
            });
            toast.success("You have successfully updated the status.");
            setInqs([
              ...tblData.map((j) =>
                j.id === res?.result.id
                  ? {
                      ...j,
                      status: res.result.status === 2 ? "closed" : "completed",
                    }
                  : j
              ),
            ]);
          } else if (res) {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res?.msg,
            });
          }
        };
        API(controller.Inquiry + action.UpdateStatus).post(
          ToFormData({ ...value, updateDate: new Date().toISOString() }),
          onComplete
        );
      },
    });
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure",
      subTitle: "You want to delete this inquiry?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Deleted Successfully",
              subTitle: res?.msg,
            });
            setInqs((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else if (res) {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res?.msg,
            });
          }
        };
        API(controller.Inquiry).Delete(id, onComplete);
      },
    });
  };

  useEffect(() => {
    setTblData([
      ...inqs.map((j) => ({
        ...j,
        statusWidget: <InquiryStatusWidget status={j.status} />,
      })),
    ]);
    return () => {};
  }, [inqs]);

  return (
    <>
      <DynamicTable
        records={tblData}
        setRecords={setInqs}
        endpointKey={controller.Inquiry + action.GetAllByOrg}
        exportEndpoint={controller.Inquiry + action.ExportInquiries}
        enableDateRange={true}
        enableExport={access?.inquery?.export}
        ActionComp={(param) => (
          <Actions
            {...{
              param,
              access,
              handleView,
              handleAddEdit,
              handleDlt,
              handleFollowup,
              handleUpdateStatus,
            }}
          />
        )}
        HeaderComp={() => <Header {...{ access }} />}
        headers={[
          { id: "actions", label: "Actions" },
          { id: "statusWidget", label: "Status" },
          { id: "fullName", label: "Name" },
          { id: "phone", label: "Phone" },
          { id: "email", label: "Email" },
          { id: "remark", label: "Remark" },
        ]}
      />

      {/* Add Follow Up */}
      {followUp && (
        <Dialog show={followUp} onClose={false} maxWidth="xs">
          <AddEditFollowUp
            {...{ setShowForm: setFollowUp, setAlert, inqData }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Inquiries;
